import { Form, Formik } from "formik";
import { check } from "../../../resources/js/images";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import CustomButton from "../../../shared/ui/CustomButton";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import { InsightformSchema } from "../../../shared/ui/Form/schema";

const InsightsForm = ({
    onSuccess,
    inverters,
    credentials,
    testConn,
    testConnection,
}) => (
    <div className="p-4">
        <Formik
            initialValues={{
                inverter: inverters[0]?.value || "SUN_GROW",
                email: credentials?.email,
                password: credentials?.password,
            }}
            validationSchema={InsightformSchema}
            onSubmit={onSuccess}
        >
            {({ values }) => (
                <Form className="flex flex-col gap-2">
                    <LabeledFormikSelect
                        label="Inverter"
                        name="inverter"
                        wrapperClassName={"mb-0"}
                        required
                        options={
                            inverters?.length > 0
                                ? inverters
                                : [
                                      { label: "Sun Grow", value: "SUN_GROW" },
                                      { label: "Grow", value: "Grow" },
                                      { label: "Sun", value: "Sun" },
                                  ]
                        }
                    />
                    <FormikLabeledInput
                        label="Email Id"
                        name="email"
                        required
                    />
                    <FormikLabeledInput
                        label="Password"
                        name="password"
                        type="password"
                        required
                    />
                    <div className="flex gap-2 items-center">
                        <CustomButton
                            text="Test Connection"
                            color="primary"
                            className="w-full"
                            onClick={() => testConnection(values.inverter)}
                        />
                        <Button className="w-full" type="submit">
                            Enable Insights
                        </Button>
                    </div>

                    {testConn && (
                        <div className="flex items-center gap-0.5 rounded-xl bg-gray-100 py-0.5 px-1 justify-center mt-1">
                            <P className="text-xs 2xs:text-nowrap">
                                Sun Grow account connected successfully
                            </P>
                            <img
                                src={check}
                                alt="success"
                                className="w-2 h-2"
                            />
                        </div>
                    )}
                </Form>
            )}
        </Formik>
    </div>
);

export default InsightsForm;
